import * as yup from "yup";

export interface FormData {
  companyName: string;
  cvrNr: string;
  subject: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  department: string;
}

yup.setLocale({
  mixed: {
    required: "Dette felt er obligatorisk",
  },
  string: {
    email: "Ugyldig email adresse",
    length: "Dette felt er for kort",
  },
});

export const validationSchema = () => {
  return yup.object().shape({
    companyName: yup.string().required().trim(),
    cvrNr: yup.string().required().trim().strict().min(8),
    subject: yup.string().required().trim(),
    firstName: yup.string().required().trim(),
    lastName: yup.string().required().trim(),
    email: yup.string().required().trim().email(),
    phoneNumber: yup.string().required().trim().strict().min(6),
    department: yup.string().required(),
  });
};

export const formToText = (formData: FormData) => {
  let text = "";
  text = text + `Company name: ${formData.companyName}, `;
  text = text + `CVR nr: ${formData.cvrNr}, `;
  text = text + `Subject: ${formData.subject}, `;
  text = text + `First name: ${formData.firstName}, `;
  text = text + `Last name: ${formData.lastName}, `;
  text = text + `Email: ${formData.email}, `;
  text = text + `Phone number: ${formData.phoneNumber}, `;
  text = text + `Department: ${formData.department}`;
  return text;
};

export default validationSchema;
